export const email = "hello@kevin-guy.co.uk";
export const available = true;
